import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it paper or digital?',
  a: 'It is a 100% digital product (High-Resolution PDF) that combines 6 professional guides in 1 complete system, optimized for viewing on iPad, Tablet, Laptop or Smartphone — so you can access it directly in the studio during your classes.'
}, {
  q: 'Do I need to be an expert to use it?',
  a: 'Not at all. DANCE READY™ is designed for instructors at every stage — whether you completed your first teaching qualification last month or have been running a studio for years. The system adapts to your level and your students.'
}, {
  q: 'Does it work for different dance styles?',
  a: 'Yes. Every class structure, movement framework and planning template inside DANCE READY™ is designed to work across jazz, contemporary, hip hop, commercial dance, dance fitness and creative movement — not just one style.'
}, {
  q: 'Does it work for studio and online classes?',
  a: 'Yes. Every class outline, planning template and resource inside DANCE READY™ is designed to work in a physical studio, a home setup or a live online class format — with zero adaptation required.'
}, {
  q: 'How quickly will I see results?',
  a: 'Most instructors report saving between 3 and 5 hours of planning time from their very first week. The ready-to-teach class collection alone gives you 30 complete classes you can deliver immediately.'
}, {
  q: 'Can I print the materials for the studio?',
  a: 'Yes, all guides and templates are printer-friendly. Many instructors print the Class Builder Framework and keep it in a binder at the studio.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment of $27. You get lifetime access to the entire DANCE READY™ system and all bonuses with no recurring fees.'
}, {
  q: 'What age groups is this suitable for?',
  a: 'The frameworks are highly adaptable and can be used for teaching children, teens, and adults. The principles of flow and progression apply to all age groups.'
}, {
  q: 'Do I get access to the bonuses immediately?',
  a: 'Yes! All 5 luxury bonuses are included with your purchase today and will be delivered instantly alongside the main system.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply email us within 7 days of your purchase, and we will issue a full, no-questions-asked refund. Your investment is 100% risk-free.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-6 px-4 sm:px-6 bg-white" data-id="element-37" data-mp="2ylqnizftw9e4">
      <div className="text-center mb-4" data-id="element-38" data-mp="2um9fpzcxj05s">
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-brand-taupe mb-1 uppercase leading-tight" data-id="element-39" data-mp="2ul6pltnfl1qx">
          FREQUENTLY ASKED QUESTIONS
        </h2>
      </div>

      <div className="flex flex-col gap-1.5" data-id="element-40" data-mp="1j5i313e3a4qn">
        {faqs.map((faq, i) => <div key={i} className="bg-brand-cream border border-brand-beige rounded overflow-hidden shadow-sm" data-id="element-41" data-mp="3uug7dvpncvnl" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-3 py-2.5 text-left flex justify-between items-center hover:bg-brand-beige/30 transition-colors gap-2" data-id="element-42" data-mp="2qdpcg7vu1ud">
              <span className="font-bold text-brand-taupe text-xs sm:text-sm leading-tight" data-id="element-43" data-mp="hfa38twme92w">
                {faq.q}
              </span>
              <ChevronDownIcon className={`w-4 h-4 text-brand-rose transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-44" data-mp="mcs2ttoqzby8" />
            </button>

            {openIndex === i && <div className="px-3 pb-2.5 pt-0 text-brand-taupe/80 font-medium text-xs sm:text-sm leading-tight" data-id="element-45" data-mp="vcf7qpgoqzw1">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </section>;
}